import { createLogic } from 'redux-logic'
import Api from '@app/api/groups'
import handleErrors from '@app/helpers/handleErrors'
import { GROUPS_ADD_DEVICE } from '@app/constants/groups/groups'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'

const postGroupDevice = createLogic({
  type: GROUPS_ADD_DEVICE,
  cancelType: API_REQUEST_CANCEL,

  process({ action }, dispatch, done) {
    const { secrets: { accessToken: { token: AccessToken } } } = store.getState()
    dispatch(apiRequestSent(GROUPS_ADD_DEVICE))
    const result = action.zwave
      ? Api.groupAddDeviceZwave(AccessToken, action.deviceId, action.groupId)
      : Api.groupAddDeviceTwr(AccessToken, action.deviceId, action.groupId)
    result
      .then(() => {
        dispatch(apiRequestDone(GROUPS_ADD_DEVICE))
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
        } else {
          throw new Error('groupAddDeviceZwave or groupAddDeviceTwr failed without error')
        }
      })
      .then(() => done())
  },
})

export default postGroupDevice
